export const STATES = [
  "Arizona", "California", "Nevada", "Utah", "New Mexico", "Texas", "Colorado",
  "Washington", "Oregon", "Idaho", "Florida", "Georgia", "Illinois", "New York",
  "Pennsylvania", "Ohio", "Michigan", "North Carolina", "Tennessee", "Virginia",
  "Missouri", "Indiana", "Oklahoma", "Louisiana",
];

export const SERVICE_OPTIONS = [
  "Attorney",
  "Medical / Doctor",
  "Body Shop Repair",
  "Towing / Rental Car",
  "Complete All-In-One Support",
];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BRAND = {
  phone: "928-605-5841",
  phoneHref: "tel:9286055841",
  email: "collisionqueens@gmail.com",
};
